import React from "react";

import Zar8AssetPageContent from "../../components/Zar8AssetPageContent";
import Header from "../../layouts/Header";

export default function Zar8AssetPage({
  basePath = "/zar8/asset",
  routeFlowType = null,
}) {
  return (
    <div className="min-h-screen bg-[#F8F8F8]">
      <Header />
      <Zar8AssetPageContent basePath={basePath} routeFlowType={routeFlowType} />
    </div>
  );
}
